module.exports = __webpack_public_path__ + "img/top_bg.16b76098.jpg";